const usersEn = {
    profile: require('../../lang/en/users/Profile').default,
};

export default usersEn;